export const locales = {
    name: 'свое имя',
    phone: 'свой телефон',
    message: 'комментарий',
}
